<template>
  <v-dialog persistent v-model="modalDel" max-width="550" dark>
    <div id="modal-del-report">
    <div v-if="loader" class="loader">
      <v-icon>mdi-loading mdi-spin</v-icon>
    </div>

    <!-- Modal Card -->
    <v-card>
      <v-card-title class="headline">
        <v-icon color="warning">warning</v-icon>
        <p>
          {{$t('titles.deleteImgs')}}  
        </p>
      </v-card-title>
      <v-card-text>
        <ul>
          <div v-for="(report, index) in selectedReports" :key="index">
            <li v-if="report !== undefined" class="mb-2">
                <strong>{{report.srcName}} :</strong> <br> &#9; 
              <span v-if="report.labelName === 'BASIC'" v-html="$t('texts.delReportBASIC')">
              </span>
              <span v-else-if="report.labelName.includes('AOI: ')" v-html="$t('texts.delReportAOI', {name: report.labelName})">
              </span>
              <span v-else-if="report.labelName === 'ALL'" v-html="$t('texts.delReportALL')">
              </span>
            </li>
          </div>
        </ul>
      </v-card-text>
      <v-card-actions class="center">
        <v-btn color="primary" flat @click="hide">{{$t('buttons.cancel')}}</v-btn>
        <v-btn color="primary" flat @click="confirmDelete">{{$t('buttons.deleteAll')}}</v-btn>
      </v-card-actions>
    </v-card>
    </div>
  </v-dialog>
</template>
<script>
export default {
  props: {
    reports: Object
  },
  data() {
    return {
      loader: false,
      selectedReports: null
    };
  },
  watch: {
    modalDel(showing) {
      if (showing === true) 
        this.updateSelectedReports();
    }
  },
  computed: {
    modalDel() {
      let status = this.$store.getters["image/getModalDelImg"];
      return status;
    },
  },
  methods: {
    hide() {
      this.$store.commit('image/setModalDelImg', false);
    },
    async confirmDelete() {
      if (this.selectedReports === null) return;
      this.loader = true;

      // manage delete
      let deletingActions = this.selectedReports.map((report) => {
        if (report.labelName === 'BASIC' || report.labelName === 'ALL' || report.labelName === '')
          return this.$store.dispatch('image/deleteMedia', report.srcUuid);
        else if (report.labelName.includes('AOI: ')) 
          return this.$store.dispatch('report/deleteAOIReport', report.uuid);
      })
      await Promise.all(deletingActions);
      // end manage delete

      setTimeout(() => {
        this.loader = false;
      }, 300);
      this.hide();
    },
    updateSelectedReports() {
      if (Object.keys(this.reports).length === 0) 
        return this.selectedReports = null;
      let selectedImgs = this.$store.getters["image/getMultiSelectImg"];
      let selectedReports = selectedImgs.map(imgUuid => {
        this.reports[imgUuid].srcUuid = imgUuid;
        return this.reports[imgUuid];
      });
      this.selectedReports = selectedReports;
    }
  }
};
</script>
<style lang="sass">
#modal-del-report 
  position: relative
  li 
    word-break: break-word
  .v-btn:focus 
    outline: none

  .headline 
    display: flex !important
    i
      flex: 1
    p
      flex: 5
      margin: 0

  .loader 
    position: absolute
    width: 100%
    height: 100%
    z-index: 1000
    background-color: rgba(0, 0, 0, .5)

  .loader i 
    position: absolute
    z-index: 1050
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    font-size: 3rem

</style>